/**
 * Case answers as the app holds them: every time in milliseconds. See
 * docs/rules/api_boundary.md.
 */

import type {
    Case, CaseAttachment, CaseAttachmentContent, CaseAttachmentContentDto, CaseAttachmentDto,
    CaseDetail, CaseDetailDto, CaseDto,
} from '@/types/cases';
import {
    CaseAttachmentContentDtoSchema, CaseAttachmentDtoSchema, CaseDetailDtoSchema, CaseDtoSchema,
} from '@/types/cases';

export function toAttachment(dto: CaseAttachmentDto): CaseAttachment {
    const { addedAt, updatedAt, ...rest } = dto;
    return {
        ...rest,
        addedAtMs: Date.parse(addedAt),
        updatedAtMs: Date.parse(updatedAt),
    };
}

export function toCase(dto: CaseDto): Case {
    const { createdAt, updatedAt, ...rest } = dto;
    return {
        ...rest,
        createdAtMs: Date.parse(createdAt),
        updatedAtMs: Date.parse(updatedAt),
    };
}

export function toCaseDetail(dto: CaseDetailDto): CaseDetail {
    const { attachments, bookmarks, ...bare } = dto;
    return {
        ...toCase(bare),
        attachments: attachments.map(toAttachment),
        bookmarks,
    };
}

export function toCaseAttachmentContent(
    dto: CaseAttachmentContentDto,
): CaseAttachmentContent {
    return {
        url: dto.url,
        expiresAtMs: Date.parse(dto.expiresAt),
    };
}

export const CaseSchema = CaseDtoSchema.transform(toCase);
export const CaseDetailSchema = CaseDetailDtoSchema.transform(toCaseDetail);
export const CaseAttachmentSchema = CaseAttachmentDtoSchema.transform(toAttachment);
export const CaseAttachmentContentSchema =
    CaseAttachmentContentDtoSchema.transform(toCaseAttachmentContent);
